import { useTranslation } from "react-i18next"
import { GlobeIcon, CheckIcon } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu"
import { Button } from "components/ui/button"
import { cn } from "lib/utils"

const languages = {
  en: "English",
  es: "Español",
}

type LanguageCode = keyof typeof languages

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation()

  const currentLanguage = i18n.language as LanguageCode

  const changeLanguage = (lng: LanguageCode) => {
    i18n.changeLanguage(lng)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="focus-visible:ring-0"
          aria-label="Language Switcher"
        >
          <GlobeIcon size={16} />
          <span className="sr-only">{t("common.switchLanguage")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="space-y-1">
        {Object.entries(languages).map(([code, name]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => changeLanguage(code as LanguageCode)}
            className={cn(
              currentLanguage === code ? "font-bold bg-accent" : "",
              "relative pl-8"
            )}
          >
            {currentLanguage === code && (
              <CheckIcon className="size-4 absolute left-2 top-1/2 transform -translate-y-1/2" />
            )}
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
